// Our bundles are served from the same origin as the page, so a genuine
// first-party error always has at least one frame served from the document's
// origin. Only frames whose filename carries a URL scheme (`https://`,
// `chrome-extension://`, and the like) are considered; a frame with no such
// filename (inline/eval/native) can't be attributed to anyone, so an event made
// up only of those is kept. When every attributable frame is off-origin, the
// error didn't come from our code and isn't worth paying to ingest.
//
export default function isThirdPartyOnly(frames) {
  const attributableFrames = frames.filter(({ filename }) => filename?.includes('://'))

  if ( !attributableFrames.length ) {
    return false
  }

  const firstPartyPrefix = `${ window.location.origin }/`

  return !attributableFrames.some(({ filename }) => filename.startsWith(firstPartyPrefix))
}
